import { DialogClose } from '@radix-ui/react-dialog'
import { Cross2Icon } from '@radix-ui/react-icons'
import React, { FC } from 'react'
import styled from 'styled-components'
import ModalContainer from './ModalContainer'

interface ModalWithCloseCrossProps {
  open: boolean
  onClose: () => void
  children?: React.ReactNode
}

const ModalWithCloseCross: FC<ModalWithCloseCrossProps> = (props) => {
  const { onClose, open, children } = props

  return (
    <ModalContainer open={open}>
      <DialogClose asChild onClick={() => onClose()}>
        <IconButton>
          <Cross2Icon />
        </IconButton>
      </DialogClose>
      {children}
    </ModalContainer>
  )
}
const IconButton = styled.button`{
  all: unset;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  color: #D0D0D0;
  cursor: pointer;
  align-self: flex-end;
`

export default ModalWithCloseCross
